module.exports = __webpack_public_path__ + "static/noticias-07-89b286e36ed35a476667938828dcb071.jpg";